import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import Filter from "../../../components/Common/Filter";
import {
  activeInactiveOptions,
  defaultDeleteModelState,
} from "../../../utilities/const";
import TableActions from "../../../components/Common/TableActions";
import { DELETE_USER, USER_LIST } from "../../../services/ApiCalls";
import moment from "moment";
import Toggle from "../../../components/Common/Toggle";
import {
  exportCsvHandler,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../utilities/utilities";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import { useTranslation } from "react-i18next";
import FeatureUser from "../../../components/Common/FeatureUser";

const ManageUser = () => {
  const { t } = useTranslation();
  const [exportLoader, setExportLoader] = useState(false);
  const [status, setStatus] = useState("inactive");

  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: USER_LIST,
    extraBody: { ROLE: "USER" },
  });

  const column = [
    {
      head: t("manageUser.columns.srNo"),
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    {
      head: t("manageUser.columns.username"),
      accessor: "name",
      component: (item) => (
        <p className="m-0 fw-semibold text-capitalize">
          {item.first_name || "-"} {item.last_name || "-"}
        </p>
      ),
    },
    {
      head: t("manageUser.columns.email"),
      accessor: "email",
      component: (item) => (
        <p
          className="m-0 fw-sbold text-break"
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            maxWidth: "200px",
          }}
        >
          {item.email || "--"}
        </p>
      ),
    },
    {
      head: t("manageUser.columns.phoneNumber"),
      accessor: "mobileNumber",
      component: (item) => <p className="m-0">{item.mobileNumber || "-"}</p>,
    },
    // {
    //   head: t("manageUser.columns.numberOfBooking"),
    //   accessor: "numberOfBooking",
    //   component: (item) => (
    //     <p className="m-0 d-flex justify-content-center align-items-center">
    //       {item.numberOfBooking || "0"}
    //     </p>
    //   ),
    // },
    // {
    //   head: t("manageUser.columns.avgRating"),
    //   accessor: "avgRating",
    //   component: (item) => (
    //     <p className="m-0 d-flex justify-content-center align-items-center">
    //       {item.avgRating || "0"}
    //     </p>
    //   ),
    // },

    {
      head: t("manageUser.columns.registeredAt"),
      accessor: "createdAt",
      component: (item) => (
        <p className="m-0" style={{ color: "#E8307A" }}>
          {moment(item.createdAt).format("DD/MMM/YYYY")}
        </p>
      ),
    },
    // {
    //   head: t("manageUser.columns.numberOfLastBooking"),
    //   accessor: "lastBookingDate",
    //   component: (item) => (
    //     <p className="m-0" style={{ color: "#E8307A" }}>
    //       {item.lastBookingDate
    //         ? moment(item.lastBookingDate).format("DD/MMM/YYYY")
    //         : "--"}
    //     </p>
    //   ),
    // },
    {
      head: t("manageUser.columns.status"),
      accessor: "status",
      component: (item) => (
        <span
          style={{
            color:
              item.status?.toLowerCase() === "active"
                ? "green"
                : item.status?.toLowerCase() === "inactive"
                ? "red"
                : "#000",
            fontWeight: 500,
            textTransform: "capitalize",
          }}
        >
          {item.status || "--"}
        </span>
      ),
    },
    {
      head: t("manageUser.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          editUrl={`/manage-user/edit/${item._id}`}
          viewLink={`/manage-user/detail/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_USER({ _id: deleteModel.dumpId }))
        }
        type={"delete"}
      />
      <section className="manageUser  position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 fw-bold text-dark text-capitalize">
                  {t("manageUser.title")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <FeatureUser platform={data?.platform} />
            </Col>

            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-end justify-content-between flex-wrap gap-10 mb-3">
                <div className="d-flex align-items-center gap-4">
                  {/* <div className="d-flex align-items-center gap-2 flex-column">
                    <label
                      htmlFor="countryFilter"
                      className="form-label m-0 fw-semibold text-muted"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {t("manageUser.filter")}
                    </label>
                    <CountryFilter
                      id="countryFilter"
                      body={body}
                      setBody={setBody}
                    />
                  </div> */}
                  <div className="left">
                    <Filter
                      body={body}
                      setBody={setBody}
                      searchHandler={searchHandler}
                      statusFilterOptionArr={activeInactiveOptions}
                    />
                  </div>
                </div>

                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("users", setExportLoader)
                        }
                      >
                        {exportLoader ? (
                          <ButtonLoader />
                        ) : (
                          t("manageUser.exportCsv")
                        )}
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <TableLayout
                column={column}
                data={data?.resdata}
                loader={loader}
              />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageUser;
